import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 0910. 発注案件契約タスクファイル削除
 * [DELETE] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_contract_tasks/:task_id/purchase_order_contract_task_documents/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
  id: number;
};

const destroyPurchaseOrderContractTaskDocument = (props: Props): Promise<any> => {
  return axios.delete(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/purchase_order_contract_tasks/${props.task_id}/purchase_order_contract_task_documents/${props.id}`
  );
};

export const useDestroyPurchaseOrderContractTaskDocument = () => {
  return useMutation({
    mutationFn: destroyPurchaseOrderContractTaskDocument,
  });
};
